import { clone } from '../../helpers/';
import { IComponentType, ISearchLocation, EComponentTypes, ISharedJourneyItem,IJourneyItem } from '../../helpers';
import types from '../types';

interface ISearchState {
    term: string;
    suggestions: IComponentType[];
    searchLocation: ISearchLocation;
    sharedJourneyResults: ISharedJourneyItem[];
    upgradeJourneysResults:IJourneyItem[];
    sharedJourneyTerm: string;
    sharedJourneySearchComponentId: string;
    sharedJourneyAwaitingResults: boolean;
    preventBlur?: boolean;

};

const initialSearchLocation: ISearchLocation = {
    branchId: 'root',
    loopComponentId: null,
    ComponentId: null
};

const initialState:ISearchState = {
    term: '',
    suggestions: [],
    searchLocation: initialSearchLocation,
    sharedJourneyResults: [],
    sharedJourneyTerm: '',
    sharedJourneySearchComponentId: '',
    sharedJourneyAwaitingResults: false,
    upgradeJourneysResults:[]
};

const searchReducer = function(state:ISearchState = initialState, action) {

    let stateClone:ISearchState = clone(state);

    switch(action.type) {

        case types.GET_SUGGESTIONS:
            stateClone = updateList(stateClone, action.search, action.componentTypes, action.passedSubmissionComponent, action.isSharedJourney);
            break;

        case types.SET_SEARCH_LOCATION:
            stateClone = setSearchLocation(stateClone, action.searchLocation);
            break;
        

        case types.SET_PREVENT_SEARCH_BLUR:
            stateClone = setPreventBlur(stateClone, action.preventBlur);
                break;

        case types.SET_SHARED_JOURNEY_SEARCH:
            stateClone = setSharedJourneySearch(stateClone, action.sharedJourneyResults, action.searchTerm, action.componentId);
            break;
            case types.SET_UPGRADE_JOURNEYS_SEARCH:
            stateClone = setUpgradeJourneysResults(stateClone, action.upgradeJourneysResults, action.searchTerm, action.componentId);
            break;
        default:
            break;

    }

    return stateClone;

};

let updateList = (state: ISearchState, term: string, componentTypes: IComponentType[], passedSubmissionComponent:boolean, isSharedJourney: boolean): ISearchState => {
    
    state.term = (term || '').toLowerCase();

    if (!state.searchLocation.ComponentType) {
        state.suggestions = [componentTypes[EComponentTypes.step]];
    }
    else {

        /**
         * after a Submission component has been encountered, then only an action, summary or redirect may follow
         * in the case of a Summary/Redirect component, revert to list of Allowed components determined by API
         */
        let allowedComponentTypes: EComponentTypes[] = [];

        if(passedSubmissionComponent && (
            state.searchLocation.ComponentType.ComponentTypeId !== EComponentTypes.summary && 
            state.searchLocation.ComponentType.ComponentTypeId !== EComponentTypes.redirect)
         ) {
            allowedComponentTypes = [EComponentTypes.action, EComponentTypes.summary, EComponentTypes.redirect];
        }
        else if(state.searchLocation.loopComponentId) {
            allowedComponentTypes = state.searchLocation.ComponentType.AllowedInsideLoop;
        }
        else {
            allowedComponentTypes = state.searchLocation.ComponentType.Allowed.concat([EComponentTypes.summary, EComponentTypes.redirect]);
        }

        state.suggestions = allowedComponentTypes.map(
            (componentTypeId) => {
                return componentTypes[componentTypeId];
            }
        )
        .filter(c => {
            if(isSharedJourney && c.Name.toLowerCase() === 'shared journey') {
                return false;
            }
            return !(c.Name.toLowerCase().indexOf(state.term));
        });

    }

    return state;
};

const setPreventBlur = (state: ISearchState, preventBlur: boolean): ISearchState => {

    state.preventBlur = preventBlur;
    return state;

};

let setSearchLocation = (state: ISearchState, searchLocation: ISearchLocation): ISearchState => {

    state.searchLocation = searchLocation || initialSearchLocation;
    return state;

};

let setSharedJourneySearch = (state: ISearchState, sharedJourneyResults: any, searchTerm: string, componentId: string): ISearchState => {

    state.sharedJourneyResults = sharedJourneyResults;
    state.sharedJourneyTerm = searchTerm;
    state.sharedJourneySearchComponentId = componentId;

    return state;
};

let setUpgradeJourneysResults = (state: ISearchState, upgradeJourneysResults: any, searchTerm: string, componentId: string): ISearchState => {

    state.upgradeJourneysResults = upgradeJourneysResults;
    state.sharedJourneyTerm = searchTerm;
    state.sharedJourneySearchComponentId = componentId;

    return state;
};

export default searchReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/search.ts